import { render, staticRenderFns } from "./SmsTemplateFormDialog.vue?vue&type=template&id=7f0d6cd4&scoped=true"
import script from "./SmsTemplateFormDialog.vue?vue&type=script&lang=js"
export * from "./SmsTemplateFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0d6cd4",
  null
  
)

export default component.exports